(() => {
  function initGuide(root) {
    if (root.dataset.msGuideReady) return;
    root.dataset.msGuideReady = 'true';
    const dialog = root.querySelector('[data-ms-guide-dialog]');
    const trigger = root.querySelector('[data-ms-guide-open]');
    let previousOverflow;
    trigger.addEventListener('click', () => {
      if (dialog.open) return;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
    root.querySelector('[data-ms-guide-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow || '';
      trigger.focus();
    });
  }
  function init(root) {
    if (root.dataset.msReady) return;
    root.dataset.msReady = 'true';
    const form = root.querySelector('form');
    const params = new URLSearchParams(window.location.search);
    const returnLinks = root.querySelector('[data-ms-collection-return]');
    const sourceCollection = params.get('sun_collection');
    const returnLink = Array.from(root.querySelectorAll('[data-ms-return]')).find(link => link.dataset.msReturn === sourceCollection);
    if (returnLinks && returnLink) {
      const url = new URL(returnLink.href, window.location.origin);
      const preview = params.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      returnLink.href = url.href;
      returnLink.hidden = false;
      returnLinks.hidden = false;
    }
    const swatches = Array.from(root.querySelectorAll('[data-ms-tint]'));
    const variantInput = root.querySelector('[data-ms-variant-id]');
    const tintLabel = root.querySelector('[data-ms-tint-label]');
    const button = root.querySelector('[data-ms-buy]');
    const message = root.querySelector('[data-ms-message]');
    const variants = JSON.parse(root.querySelector('[data-ms-variants]').textContent);
    const ids = new Set(swatches.map(swatch => Number(swatch.dataset.variantId)));
    let selectedSwatch = swatches.find(swatch => !swatch.disabled) || swatches[0];
    let previousVariant, pending = false;
    const selectVariant = () => {
      const variant = variants.find(v => v.id === Number(selectedSwatch?.dataset.variantId) && ids.has(v.id));
      variantInput.value = variant?.id || '';
      tintLabel.textContent = selectedSwatch?.dataset.label || '';
      swatches.forEach(swatch => {
        const selected = swatch === selectedSwatch;
        swatch.classList.toggle('is-selected', selected);
        swatch.setAttribute('aria-pressed', String(selected));
      });
      button.disabled = !variant?.available || pending;
      const section = root.closest('.shopify-section');
      const price = section?.querySelector('[data-ms-price]');
      if (price && selectedSwatch) price.textContent = selectedSwatch.dataset.price;
      section?.querySelectorAll('[data-cocoleni-vto]').forEach(el => { el.dataset.variant = variant?.id || ''; });
      if (variant) {
        form.dispatchEvent(new CustomEvent('variant:change', {bubbles: true, detail: {formId:form.id, variant, previousVariant}}));
        previousVariant = variant;
      }
      return variant;
    };
    swatches.forEach(swatch => swatch.addEventListener('click', () => {
      if (swatch.disabled || pending) return;
      selectedSwatch = swatch;
      message.textContent = '';
      selectVariant();
    }));
    selectVariant();
    customElements.whenDefined('product-gallery').then(() => requestAnimationFrame(selectVariant));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending) return;
      const variant = selectVariant();
      if (!variant?.available) { message.textContent = message.dataset.soldOut; return; }
      pending = true;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = message.dataset.busy;
      try {
        const prefix = window.Shopify?.routes?.root || '/';
        await customElements.whenDefined('cart-drawer');
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true,detail:{sections}}));
        const response = await fetch(`${prefix}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections:[...new Set(sections)].slice(0,5),sections_url:`${prefix}variants/${variant.id}`})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || message.dataset.error);
        message.textContent = message.dataset.success;
        try {
          const cartResponse = await fetch(`${prefix}cart.js`, {headers:{Accept:'application/json'}});
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          const cart = await cartResponse.json();
          cart.sections = data.sections;
          if (sections.some(id => !cart.sections?.[id])) throw new Error('Cart sections unavailable');
          const detail = {items:data.items || [data],cart,onSuccessDo:'force_open_drawer'};
          form.dispatchEvent(new CustomEvent('variant:add', {bubbles:true,detail}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
          root.querySelector('[data-ms-view-cart]').hidden = true;
        } catch {
          root.querySelector('[data-ms-view-cart]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) { message.textContent = error.message || message.dataset.error; }
      finally { pending = false; button.textContent = original; selectVariant(); }
    });
  }
  document.querySelectorAll('[data-ms-purchase]').forEach(init);
  document.querySelectorAll('[data-ms-size-guide]').forEach(initGuide);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ms-size-guide]').forEach(initGuide));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ms-purchase]').forEach(init));
})();
